module.exports = __webpack_public_path__ + "static/media/lang-it.f76c5ba1.svg";